import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ContactUs = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    orderNumber: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: '',
        orderNumber: ''
      });
      
      // Reset status after 5 seconds
      setTimeout(() => {
        setSubmitStatus(null);
      }, 5000);
    }, 1500);
  };

  return (
    <div className="page-content">
      <div className="policy-page">
        <button 
          className="btn outline" 
          onClick={() => navigate(-1)}
          style={{ marginBottom: '2rem' }}
        >
          ← Back
        </button>
        
        <div className="policy-header">
          <h1 className="policy-title">📞 Contact Us</h1>
          <p className="policy-date">We're here to help you!</p>
        </div>
        
        <div className="policy-content">
          <div className="policy-section">
            <p>Have questions, feedback, or need assistance? We're always happy to hear from our valued customers. Choose the best way to reach us below.</p>
          </div>

          <div className="policy-section">
            <h3>📧 Email Support</h3>
            <div style={{ 
              background: '#f0f9ff', 
              padding: '1.5rem', 
              borderRadius: '12px',
              marginBottom: '1.5rem'
            }}>
              <p><strong>Primary Contact:</strong> support@neoteeforge.com</p>
              <p><strong>Response Time:</strong> Within 24-48 business hours</p>
              <p><strong>Best For:</strong> General inquiries, order issues, account help</p>
            </div>
          </div>

          <div className="policy-section">
            <h3>⏰ Business Hours</h3>
            <div style={{ 
              background: '#fef3c7', 
              padding: '1.5rem', 
              borderRadius: '12px',
              marginBottom: '1.5rem'
            }}>
              <ul className="policy-list" style={{ listStyle: 'none', padding: 0 }}>
                <li><strong>Monday - Friday:</strong> 9:00 AM - 6:00 PM IST</li>
                <li><strong>Saturday:</strong> 10:00 AM - 4:00 PM IST</li>
                <li><strong>Sunday:</strong> Closed</li>
                <li><strong>Public Holidays:</strong> Closed</li>
              </ul>
              <p><small>*Response times may be longer outside business hours</small></p>
            </div>
          </div>

          <div className="policy-section">
            <h3>📝 Contact Form</h3>
            <p>Fill out the form below and we'll get back to you as soon as possible.</p>
            
            <form className="contact-form" onSubmit={handleSubmit}>
              {submitStatus === 'success' && (
                <div style={{
                  background: '#d1fae5',
                  color: '#065f46',
                  padding: '1rem',
                  borderRadius: '8px',
                  marginBottom: '1.5rem',
                  borderLeft: '4px solid #10b981'
                }}>
                  ✅ Thank you for your message! We'll get back to you within 24 hours.
                </div>
              )}
              
              <div className="form-group">
                <label className="form-label">Full Name *</label>
                <input
                  type="text"
                  name="name"
                  className="form-input"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Enter your full name"
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Email Address *</label>
                <input
                  type="email"
                  name="email"
                  className="form-input"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Enter your email"
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Subject *</label>
                <select
                  name="subject"
                  className="form-input"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a subject</option>
                  <option value="order">Order Support</option>
                  <option value="download">Download Issues</option>
                  <option value="account">Account Help</option>
                  <option value="product">Product Inquiry</option>
                  <option value="refund">Refund Request</option>
                  <option value="feedback">Feedback & Suggestions</option>
                  <option value="business">Business Inquiry</option>
                  <option value="other">Other</option>
                </select>
              </div>
              
              <div className="form-group">
                <label className="form-label">Order Number (if applicable)</label>
                <input
                  type="text"
                  name="orderNumber"
                  className="form-input"
                  value={formData.orderNumber}
                  onChange={handleChange}
                  placeholder="e.g., NTF-2025-00123"
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Message *</label>
                <textarea
                  name="message"
                  className="form-input form-textarea"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Please provide details about your inquiry..."
                  rows="5"
                />
              </div>
              
              <button
                type="submit"
                className="btn primary"
                disabled={isSubmitting}
                style={{ width: '100%', padding: '1rem' }}
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>

          <div className="policy-section">
            <h3>📍 What to Include in Your Message</h3>
            <p>To help us assist you faster, please include:</p>
            <ul className="policy-list">
              <li><strong>Order number</strong> (for order-related issues)</li>
              <li><strong>Product name</strong> you're inquiring about</li>
              <li><strong>Detailed description</strong> of the issue</li>
              <li><strong>Screenshots</strong> (if applicable)</li>
              <li>Your <strong>registered email</strong> address</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3>🚀 Common Issues & Quick Solutions</h3>
            
            <div style={{ 
              background: '#f8fafc', 
              padding: '1.5rem', 
              borderRadius: '12px',
              marginTop: '1rem'
            }}>
              <h4 style={{ color: '#7c3aed', marginTop: 0 }}>Order Issues:</h4>
              <ul className="policy-list">
                <li>Check your spam folder for order confirmation</li>
                <li>Verify payment was successful</li>
                <li>Check "My Orders" in your account</li>
              </ul>
              
              <h4 style={{ color: '#7c3aed', marginTop: '1rem' }}>Download Issues:</h4>
              <ul className="policy-list">
                <li>Clear browser cache and cookies</li>
                <li>Try a different browser</li>
                <li>Check "My Library" in your account</li>
              </ul>
              
              <h4 style={{ color: '#7c3aed', marginTop: '1rem' }}>Account Issues:</h4>
              <ul className="policy-list">
                <li>Use "Forgot Password" for login issues</li>
                <li>Verify your email is correctly entered</li>
                <li>Check your internet connection</li>
              </ul>
            </div>
          </div>

          <div className="policy-section">
            <h3>🌐 Connect With Us</h3>
            <div style={{ 
              display: 'flex', 
              gap: '1rem', 
              marginTop: '1rem',
              flexWrap: 'wrap'
            }}>
              <button className="btn outline" style={{ flex: 1 }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px' }}>
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" fill="#1877F2"/>
                </svg>
                Facebook
              </button>
              
              <button className="btn outline" style={{ flex: 1 }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px' }}>
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" fill="#1DA1F2"/>
                </svg>
                Twitter
              </button>
              
              <button className="btn outline" style={{ flex: 1 }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px' }}>
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" fill="#E4405F"/>
                </svg>
                Instagram
              </button>
            </div>
          </div>

          <div style={{ 
            marginTop: '3rem', 
            paddingTop: '2rem', 
            borderTop: '1px solid #e2e8f0',
            background: '#f0fdf4',
            padding: '1.5rem',
            borderRadius: '12px'
          }}>
            <h4 style={{ color: '#059669', marginTop: 0 }}>💡 Quick Tips:</h4>
            <ul className="policy-list">
              <li>Check our FAQ section for common questions</li>
              <li>Include order numbers in all communications</li>
              <li>Be specific about your issue for faster resolution</li>
              <li>Save our email as a contact to avoid spam filters</li>
              <li>Allow 24-48 hours for email responses</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;